import { api, API_ENDPOINTS } from '../lib/api';

/**
 * Response of GET /charge-points/by-charger-id/:chargerId
 * `id` and `locationId` are internal UUIDs; `chargerId` is the human-readable
 * CSMS ID printed on the charger's QR sticker.
 */
export interface ChargePointResolveResponse {
  id: string;
  chargerId: string;
  chargerName: string;
  locationId: string;
  status: string;
  isOnline: boolean;
}

/**
 * ChargePoint Service
 * Lookups on charge points outside the location-detail flow
 */
export const chargePointService = {
  /**
   * Resolve a charge point by the human-readable CSMS charger ID
   * (as encoded in the physical charger QR stickers)
   */
  resolveByChargerId: async (chargerId: string): Promise<ChargePointResolveResponse> => {
    const response = await api.get<ChargePointResolveResponse>(
      API_ENDPOINTS.CHARGE_POINTS.BY_CHARGER_ID(chargerId)
    );
    return response.data;
  },
};
